export default "__VITE_ASSET__L_3E_eXm__"